import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Container from '../../../Core/Container';
import RichText from '../../../Core/RichText';

import { Wrapper, Copy, Spinner, Number } from './styles';

function numberWithCommas(number) {
  return Intl.NumberFormat('en-CA').format(number);
}

// * Increment Delay in Seconds
const delay = 1;

const OptimumPointCounter = ({ data }) => {
  if (!data) return null;
  const { heading, ticker, pointValue, createdAt } = data;
  const increment = parseInt(ticker, 10);
  const [count, updateCount] = useState({
    value: pointValue,
  });

  const startCounter = () =>
    setInterval(() => {
      // * Constantly increment the value of the spinner based on the delay and the increment value in the cms
      updateCount(prevState => {
        const newState = {
          value: prevState.value + increment,
        };
        return { ...prevState, ...newState };
      });
    }, delay * 1000);

  useEffect(() => {
    // * Convert Created at to a useable date formate
    const startDate = new Date(`${createdAt}`);
    // * Get the current date the user is viewing the counter at
    const endDate = new Date();
    // * Get the time difference in seconds between the start and the end date
    const seconds = Math.floor(
      (endDate.getTime() - startDate.getTime()) / 1000,
    );
    // * Calculate the additinal value that has accumulated since a cms user set the value and when a user is viewing the spinner
    const accumulatedPoints = seconds * increment;
    // * Add the newly accumulated points to the original value
    updateCount(prevState => {
      const newState = {
        value: prevState.value + accumulatedPoints,
      };
      return { ...prevState, ...newState };
    });
    // * Start a loop to increment the value by what is set in the CMS
    const id = startCounter();

    return () => {
      // * Clear the loop once a the spinner has been unmounted
      clearInterval(id);
    };
  }, []);

  return (
    <Container>
      <Wrapper>
        <Copy>
          <RichText document={heading} />
        </Copy>
        <Spinner>
          <Number aria-live="off" role="marquee">
            <sup>$</sup>
            {numberWithCommas(count.value)}
          </Number>
        </Spinner>
      </Wrapper>
    </Container>
  );
};

OptimumPointCounter.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default OptimumPointCounter;
